module.exports = __webpack_public_path__ + "ca7f1839a911516ec92fd2a789a9ced5.png";